<ng-container [ngSwitch]="conclusionStatus$ | async">
  <app-loader *ngSwitchCase="apiState.success" view="fixed" />
  <app-loader *ngSwitchCase="apiState.pending" view="policy" />
  <app-error *ngSwitchDefault [showTryAgain]="true" (tryAgain)="makeRequest()" [appError]="conclusionError$ | async"></app-error>
</ng-container>
